import { Injectable } from '@angular/core';

import { ApiStore, SearchType, SuperType } from '@fry/lib/store';

import { Blueprint } from './blueprint';
import { APIService } from '../api';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class BlueprintStore extends ApiStore<Blueprint> {
  AssociatedModel = Blueprint;

  endpoint = 'blueprints';
  docType = 'blueprint';
  superType = SuperType.Org;
  searchType = SearchType.REMOTE;

  constructor(api: APIService) {
    super(api);
  }

  allStub(): Observable<{id: string; name: string, categoryNames: { id: string, name: string }[], blueprintType: string}[]> {
    return this.api.get(`${this.endpoint}/stub`);
  }

}
